export default __webpack_public_path__ + "static/media/Lora-Bold.6925b3e1.ttf";